import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { Checkbox, Button } from '@lt/components';

import { StyledToggleIcon } from '@lt/components/components/AbstractToggler';
import FilterLabel from '../FilterLabel';

const MultipleChoiceFilter = ({
  items,
  onChange,
  visibleItems,
  expandLabel,
  className,
  LabelComponent,
  isMobile,
}) => {
  const showToggle = items.length > visibleItems;
  const [itemsToShow, setItemsToShow] = useState(
    Math.min(items.length, visibleItems),
  );
  const isClamped = itemsToShow < items.length;
  return (
    <StyledMultipleChoiceFilter className={className} isMobile={isMobile}>
      {items.slice(0, itemsToShow).map((item) => {
        const {
          id,
          path,
          selected,
          disabled,
          hotel_count: count,
          min_price: price,
        } = item;
        return (
          <StyledCheckbox
            key={`${path || 'filter'}-${id}`}
            id={id}
            checked={selected}
            disabled={disabled}
            onClick={() => onChange({ ...item, selected: !selected })}
          >
            <LabelComponent
              {...item}
              isMobile={isMobile}
              count={count}
              price={price}
            />
          </StyledCheckbox>
        );
      })}
      {showToggle && (
        <StyledToggleButton
          onClick={() =>
            setItemsToShow(isClamped ? items.length : visibleItems)
          }
        >
          {isClamped ? expandLabel : 'Скрыть'}
          <StyledToggleIcon isOpen={!isClamped} />
        </StyledToggleButton>
      )}
    </StyledMultipleChoiceFilter>
  );
};

MultipleChoiceFilter.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  visibleItems: PropTypes.number,
  expandLabel: PropTypes.string,
  LabelComponent: PropTypes.func,
  isMobile: PropTypes.bool,
};

MultipleChoiceFilter.defaultProps = {
  className: '',
  visibleItems: Infinity,
  expandLabel: 'Показать все',
  LabelComponent: FilterLabel,
  isMobile: false,
};

const StyledCheckbox = styled(Checkbox).attrs({
  options: { enableUncheckOnDisabled: true },
})`
  margin-bottom: 7px;
`;
export const StyledToggleButton = styled(Button).attrs({ functional: true })`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.greyLight};
`;
const StyledMultipleChoiceFilter = styled.div`
  ${StyledCheckbox} {
    ${({ isMobile }) =>
      isMobile &&
      css`
        flex-direction: row-reverse;
        align-items: center;
        margin: 0;
        padding: 10px;
        border-bottom: 1px solid #dcdfe4;

        &:first-child {
          border-top: 1px solid #dcdfe4;
        }

        ${StyledCheckbox.StyledWrapper} {
          margin-right: 0;
          margin-left: 8px;
        }
        /* TODO: пофиксить чекбокс */
        input[type='checkbox'] {
          width: 24px;
          height: 24px;
        }
        input[type='checkbox'] + svg {
          width: 16px;
          height: 16px;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(calc(-50%));
        }
      `}
  }
`;

export default React.memo(MultipleChoiceFilter);
